import { c as _c } from "react/compiler-runtime";
import { NotificationSettingsInterface } from 'modules/profile/notification-settings/types/notification-settings-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export const NOTIFICATION_SETTINGS_API = '/api/dashboard/settings/notifications';
export function useNotificationSettings() {
  const $ = _c(7);
  const {
    user,
    isWorkspaceOwner
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const isAllowed = isWorkspaceOwner;
  let t1;
  if ($[1] !== isAllowed || $[2] !== user) {
    t1 = () => {
      if (user && isAllowed) {
        return NOTIFICATION_SETTINGS_API;
      }
    };
    $[1] = isAllowed;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const swrData = useSWR(t1, fetcher);
  let t2;
  if ($[4] !== isAllowed || $[5] !== swrData) {
    t2 = {
      ...swrData,
      isAllowed
    };
    $[4] = isAllowed;
    $[5] = swrData;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}